// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vqzRT","input":"styles_input__2DWDX"};